(function($){
  /**
   * OH.settings.xfadeControl
   * 六本木ヒルズのトップでやっているカルーセル機能 
   * エフェクト　クロスフェード
   * 
   */
	OH.settings.xfadeControl = (function(){
		var control = new Object();

		control.crossFade = function($image, fadeImages){
			var index = 0;
			fadeImages = !!fadeImages ? fadeImages : $image.data("xfade");
			if(!fadeImages){
				return;
			}
			fadeImages = fadeImages.split("|");
			if(fadeImages.length == 1){
				return;
			}
			fadeImages = OH.settings.xfadeDefine.sort[$image.data("xfadeType") || "normal"](fadeImages);

			for(var i=0; i<fadeImages.length; i++){
				(function(src){
					var $img = $('<img>').css({ position:"absolute",top:"-9999px",left:"-9999px",width:"10px",height:"10px" }).on("load", function(){
						$img.remove();
					});
					$(document.body).append($img);
					$img.attr("src", src);
				})(fadeImages[i]);
			}

			var duration = $image.data("duration") || 1;
			duration = (duration - 0) * 1000;

			var interval = $image.data("interval") || 5;
			interval = (interval - 0) * 1000;

			if(!$image.attr("src")){
				$image.attr("src", fadeImages[0]);
			}
			$image.css({ opacity : 1, transition : "opacity " + duration + "ms linear" });

			var tasks = {
				replace : function(newImageSrc){
					var fadeinTransitionEnd = function(){
						$image.off("transitionend", fadeinTransitionEnd);
						tasks.next();
					};
					var fadeoutTransitionEnd = function(){
						$image.off("transitionend", fadeoutTransitionEnd);
						$image.attr("src", newImageSrc);
						$image.on("transitionend", fadeinTransitionEnd);
						$image.css({ opacity : 1 });
					};
					$image.on("transitionend", fadeoutTransitionEnd);
					$image.css({ opacity : 0 });

					if(OH.browserInfo.isIE && OH.browserInfo.ver < 11){
						fadeoutTransitionEnd();
						fadeinTransitionEnd();
					}
				},
				next : function(){
					window.setTimeout(function(){
						tasks.replace(fadeImages[++index % fadeImages.length]);
					}, interval);
				}
			};
			tasks.next();
		};

		control.patternedCrossFade = function($image){
			var pattern = $image.data("xfadePattern");
			var zeroPadding = function(num, length){
				return (new Array(length).join("0") + num).slice(-length);
			};
			var rangeExp = ($image.data("xfadeRange") || "0,0").split("|");
			var rangeSet = rangeExp[0].split(",");
			var zeropadLength = !!rangeExp[1] ? (rangeExp[1] - 0) : 0;

			var sources = new Array();
			for(var i=rangeSet[0]-0; i<=rangeSet[1]-0; i++){
				sources.push(pattern.replace(/\%value\%/g, zeroPadding(i, zeropadLength)));
			}
			control.crossFade($image, sources.join("|"));
		};

    
    /**
     * 
     */
    //  $('#l-mainVisual').each(function(){
    //    new OH.settings.xfadeControl.ElementalChanger($(this), "l-mainVisual");
    //    //	OH.settings.carouselControl.general($(this), "l-mainVisual");
    //  });

		control.ElementalChanger = function($parent, classPrefix){

			OH.settings.xfadeDefine.controlByHash();

			var props = OH.settings.xfadeDefine.elementalChangerProps;
			var serialName = "xfade" + new Date().getTime();

			if(sheet = OH.dynamicCSS.register(serialName, true)){
				sheet.addRule("." + props.stylePrefix + "-c-elementalxfade__list{ position:relative; }");
				sheet.addRule("." + props.stylePrefix + "-c-elementalxfade__item{ position:absolute; top:0px; left:0px; transition : opacity " + props.shiftDuration + "ms linear; }");
			}
			$parent.addClass(props.stylePrefix + '-c-elementalxfade');

			var items = new Array();
			var $targetList = $parent.find('.' + classPrefix  + '__item').eq(0).addClass(props.stylePrefix + '-c-elementalxfade__list');
			var $fadeTargets = $targetList.find('.' + classPrefix  + '__item__panel');

			var $paginations = $('<ol>').addClass(classPrefix + '__pagination');

			$parent.append($paginations);

			$fadeTargets.each(function(){
				var $li = $(this);
				var $contentPanel = $('<div>').addClass(classPrefix  + '__item__panel__content');

				$contentPanel.append($li.find('.' + classPrefix  + '__item__panel__type').eq(0));
				$contentPanel.append($li.find('.' + classPrefix  + '__item__panel__title').eq(0));
				$contentPanel.append($li.find('.' + classPrefix  + '__item__panel__date').eq(0));
				$li.append($contentPanel).addClass(props.stylePrefix + '-c-elementalxfade__item');
				items.push($li);

				var $pagination = $('<li>').addClass(classPrefix  + '__pagination__btn');
				$paginations.append($pagination);

				var imageURL = $li.data("mainImage");
				if(!!imageURL){
					var image = document.createElement("img");
					// image.onload = function(){
					// 	var color = OH.averageColor(image, image.naturalWidth, image.naturalHeight);
					// 	$li.css("background-color", "rgb(" + color.r + "," + color.g + "," + color.b + ")");
					// }
					image.src = imageURL;
					$contentPanel.after($(image).addClass(classPrefix  + "__item__panel__image"));
				}

				if(!!$li.data("href")){
					$li.css("cursor", "pointer").on("click", function(event){
						event.preventDefault();
						var href = $('<a>').attr("href", $li.data("href")).prop("href");
						window.send_ga("send", "event", "Rotation Area", "Click", href, {'nonInteraction' : 1});
						window.location.href = href;
					});
				}

				$li.find('a[href]').each(function(){
					$(this).on("click", function(event){
						event.stopPropagation();
					});
				});
			});

			var currentIndex = 0;
			var nextIndex = -1;
			var currentItem = items[currentIndex];
			var nextItem = null;
			var timer;
			var paginations = new Array();
			var autoShift = true;
			var nextInterval = props.interval;
			var midstShifting = false;
			var enoughDelay = 77;
			var observeInterval = 10;
			var transitionComplete = true;
			var tasks = {
				activate : function(index, flag){
					items[index].css({ display : flag ? "" : "none" });
					items[index][flag ? "addClass" : "removeClass"]("is-active");
				},
				fade : function(index, flag){
					items[index].css("opacity", flag ? 1 : 0);
				},
				preset : function(nextIndex, nextTask){
					items[currentIndex].css("z-index", 0);
					items[nextIndex].css("z-index", 1);
					items[currentIndex].find('.' + classPrefix  + '__item__panel__content').css('display', 'none');
					items[nextIndex].find('.' + classPrefix  + '__item__panel__content').css('display', 'block');
					tasks.fade(nextIndex, false);
					tasks.activate(nextIndex, true);
					currentItem = items[currentIndex];
					nextItem = items[nextIndex];
					window.setTimeout(nextTask, enoughDelay);
				},
				after : function(){
					tasks.activate(currentIndex, false);
					currentIndex = nextIndex;
					currentItem = nextItem;
					nextIndex = -1;
					nextItem = null;
					midstShifting = false;
					if(autoShift){
						timer = window.setTimeout(tasks.next, nextInterval);
					}
				},
				observe : function(target){
					var observer = window.setInterval(function(){
						if(Math.round(1000 * target.css("opacity")) == 1000){
							window.clearInterval(observer);
							tasks.after();
						}
					}, observeInterval);
				},
				shift : function(dest){
					if(midstShifting || currentIndex == dest){
						return;
					}
					window.clearTimeout(timer);
					midstShifting = true;
					nextIndex = dest;
					tasks.preset(dest, function(){
						tasks.fade(nextIndex, true);
						tasks.observe(nextItem);
						tasks.paging(dest);
					});
				},
				prev : function(){
					tasks.shift((currentIndex + items.length - 1)%items.length);
				},
				next : function(){
					tasks.shift((currentIndex + 1)%items.length);
				},
				paging : function(index){
					for(var i=0; i<paginations.length; i++){
						paginations[i][ i==index ? "addClass" : "removeClass"]("is-active");
					}
				}
			};

			for(var i=0; i<items.length; i++){
				tasks.fade(i, i==currentIndex);
				tasks.activate(i, i==currentIndex);
			}

			$.each($parent.find('.' + classPrefix + '__pagination__btn'), function(index){
				var button = OH.settings.xfadeDefine.paginationButton();
				$li = $(this);
				$li.on('click touchstart', function(){
					tasks.shift(index);
				});
				paginations.push($li);
			});
			tasks.paging(currentIndex);

			$parent.prepend('<div class="' + classPrefix + '__bg" / >');
			var $bg = $parent.find('.' + classPrefix + '__bg');

			var $splash = $parent.find('.' + classPrefix + '__splash');
			var $contentPanel = $parent.find('.' + classPrefix + '__item__panel__content');
			$contentPanel.css("display", "block").css('opacity', '0');

			var execStart = function(){
				$contentPanel.css('opacity', '1');
				if(items.length < 2){
					$paginations.css("display", "none");
				}
				else{
					timer = window.setTimeout(tasks.next, nextInterval);
				}
			};

      /**
       * カルーセルが動く前のスプラッシュ画像表示
       * div.l-mainVisual__splashの制御
       * DOM構造
       * <div class="l-mainVisual__splash" data-image="/assets/images/top/splash.jpg" data-timeout="5000">
       *  <div class="l-mainVisual__splash__text">WELCOME TO OMOTESANDO HILLS</div>
       * </div>
       */
			if($splash.length > 0){
				$bg.css('opacity', 0);

				$splash = $splash.eq(0);
				$paginations.css("display", "none");

				var $splText = $splash.find('.' + classPrefix + '__splash__text');

				var $splImage = $('<div>').addClass(classPrefix + '__splash__image').css("background-image", "url(" + $splash.data("image") + ")");
				$splash.append($splImage);

				var splashObserver = window.setInterval(function(){
					if($splash.css("opacity") - 0 == 0){
						window.clearInterval(splashObserver);
						if(items.length > 0){
							$splash.remove();
							$paginations.css("display", "");
							execStart();
						}
					} else if($splash.css("opacity") - 0 < 1) {
						var opacity = 1 - $splash.css("opacity");
						$contentPanel.css('opacity', opacity);
						$bg.css('opacity', opacity);
					}
				}, observeInterval);

				window.setTimeout(function(){
					$splImage.css("opacity", 1);
					$splText.css("opacity", 1);
				});

				if(items.length > 0){
					window.setTimeout(function(){
						$splash.css("opacity", 0);
					}, $splash.data("timeout") - 0);
				}
			}
			else if(autoShift && items.length > 0){
				execStart();
			}

			OH.settings.headerDefine.adjustMainVisual(serialName, $parent);
		};


		control.elementalSync = function($parent, classPrefix, callback){

			// defineでまとめる
			var props;
			props = !!props ? props : {};
			props.stylePrefix = props.stylePrefix || "";
			props.targetQuery = props.targetQuery || ">OL";
			props.targetPanelQuery = props.targetPanelQuery || ">LI";
			props.panelWidth = props.panelWidth || 100;
			props.panelWidthUnit = props.panelWidthUnit || "%";
			props.firstIndex = 0;
			props.shiftDuration = props.shiftDuration || 700;
			props.interval = props.interval || OH.settings.xfadeDefine.elementalSync.shiftInterval;

			/*
			props.autoShift = !!props.autoShift;
			props.interval = props.interval || 3000;
			props.intervalAfterAction = props.intervalAfterAction || 10000;
			props.shiftDuration = props.shiftDuration || 700;
			props.appearDuration = props.appearDuration || -1;
			props.startIndex = props.startIndex || 0;
			props.targetQuery = props.targetQuery || ">OL";
			props.targetPanelQuery = props.targetPanelQuery || ">LI";
			props.panelWidth = props.panelWidth || 600;
			props.panelWidthUnit = props.panelWidthUnit || "px";
			props.afterShift = props.afterShift || function(){};
			*/

			var transformPropName = OH.transitionalStyleProperty("transform", "_");
			var transformOriginPropName = OH.transitionalStyleProperty("transform-origin", "_");
			var cssName = props.stylePrefix || ("xfade" + new Date().getTime());

			if(sheet = OH.dynamicCSS.register(cssName, true)){
				sheet.addRule("." + props.stylePrefix + "-c-elementalxfade{ overflow:hidden; box-sizing:border-box; padding:0px; width:960px; margin:0px auto; }");
				sheet.addRule("." + props.stylePrefix + "-c-elementalxfade *{ box-sizing:border-box; list-style-type:none; }");
				sheet.addRule("." + props.stylePrefix + "-c-elementalxfade__list{ width:100%; height:100%; padding:0px; margin:0px; }");
				sheet.addRule("." + props.stylePrefix + "-c-elementalxfade__texts{ width:270px; height:100%; padding:0px; margin:0px; }");
				sheet.addRule("." + props.stylePrefix + "-c-elementalxfade__image{ width:690px; height:345px; padding:0px; margin:0px; }");
				sheet.addRule("." + props.stylePrefix + "-c-elementalxfade__item{ white-space:nowrap; transition : opacity " + props.shiftDuration + "ms linear; position:absolute; height:100%; top:0px; left:0px; }");
				sheet.addRule("." + props.stylePrefix + "-c-elementalxfade__item.is-active{  }");
			}

			$parent.addClass(props.stylePrefix + "-c-elementalxfade");


      /**
       * 
       * 
       */
			var items = new Array();
			var currentIndex = props.firstIndex;
			var nextIndex = -1;
			var currentItem = items[currentIndex];
			var nextItem = null;
			var timer;
			var autoShift = false;
			var nextInterval = props.interval;
			var midstShifting = false;
			var paginations = new Array();
			var enoughDelay = 77;
			var observeInterval = 10;
			var transitionComplete = true;
			var tasks = {
				activate : function(index, flag){
					items[index].css({ display : flag ? "" : "none" });
					items[index][flag ? "addClass" : "removeClass"]("is-active");
				},
				fade : function(index, flag){
					items[index].css("opacity", flag ? 1 : 0);
				},
				preset : function(nextIndex, nextTask){
					items[currentIndex].css("z-index", 0);
					items[nextIndex].css("z-index", 1);
					tasks.fade(nextIndex, false);
					tasks.activate(nextIndex, true);
					currentItem = items[currentIndex];
					nextItem = items[nextIndex];
					window.setTimeout(nextTask, enoughDelay);
				},
				after : function(){
					tasks.activate(currentIndex, false);
					currentIndex = nextIndex;
					currentItem = nextItem;
					nextIndex = -1;
					nextItem = null;
					midstShifting = false;
					if(autoShift){
						timer = window.setTimeout(tasks.next, nextInterval);
					}
				},
				observe : function(target){
					var observer = window.setInterval(function(){
						if(target.css("opacity") - 0 == 1){
							window.clearInterval(observer);
							tasks.after();
						}
					}, observeInterval);
				},
				shift : function(dest){
					if(midstShifting || currentIndex == dest){
						return;
					}
					window.clearTimeout(timer);
					midstShifting = true;
					nextIndex = dest;
					tasks.preset(dest, function(){
						tasks.fade(nextIndex, true);
						tasks.observe(nextItem);
						window.setTimeout(function(){
							tasks.paging(dest);
							if(!!callback && typeof callback == "function"){
								callback();
							}
						}, props.shiftDuration / 2);
					});
				},
				prev : function(){
					tasks.shift((currentIndex + items.length - 1)%items.length);
				},
				next : function(){
					tasks.shift((currentIndex + 1)%items.length);
				},
				paging : function(index){
					for(var i=0; i<paginations.length; i++){
						paginations[i][ i==index ? "addClass" : "removeClass"]("is-active");
					}
				}
			};

			var $targetList = $parent.find(props.targetQuery).eq(0);

			$targetList.addClass(props.stylePrefix + "-c-elementalxfade__list");
			$targetList.find(props.targetPanelQuery).each(function(){
				var $li = $(this);
				var $textPanel = $li.children().eq(0);

				$li.addClass(props.stylePrefix + "-c-elementalxfade__item");

				$textPanel.addClass("-c-elementalxfade__texts");

				if(!!$li.data("backgroundImage")){
					$textPanel.after($('<img>').attr("src", $li.data("backgroundImage")).addClass("-c-elementalxfade__image"));
/*
					$li.css({
						"background-image" : "url('" + $li.data("backgroundImage") + "')"
					});
*/
				}
				items.push($li);

				if(!!$li.data("href")){
					$li.css("cursor", "pointer").on("click", function(event){
						event.preventDefault();
						var href = $('<a>').attr("href", $li.data("href")).prop("href");
						window.send_ga("send", "event", "Rotation Area", "Click", href, {'nonInteraction' : 1});
						window.location.href = href;
					});
				}

				$li.find('a[href]').each(function(){
					$(this).on("click", function(event){
						event.stopPropagation();
					});
				});
			});
			if(items.length == 0){
				items.push($('<span>'));
			}

			for(var i=0; i<items.length; i++){
				tasks.fade(i, i==currentIndex);
				tasks.activate(i, i==currentIndex);
			}

			$parent.find('UL.' + classPrefix + '__controller > LI.' + classPrefix + '__controller__btn--prev').eq(0).on("click", tasks.prev);
			$parent.find('UL.' + classPrefix + '__controller > LI.' + classPrefix + '__controller__btn--next').eq(0).on("click", tasks.next);


			$.each($parent.find('.' + classPrefix + '__pagination__btn'), function(index){
				var button = OH.settings.xfadeDefine.paginationButton();
				$li = $(this);
				//$li.empty().append($(button));

				$li.on('click touchstart', function(){
					tasks.shift(index);
				});
				paginations.push($li);
			});
			tasks.paging(currentIndex);

			if(autoShift && items > 0){
				timer = window.setTimeout(tasks.next, nextInterval);
			}

			var breakPoint = OH.settings.xfadeDefine.elementalSync.breakPoint;
			var contentMaxWidth = OH.settings.xfadeDefine.elementalSync.contentMaxWidth;
			var contentMinWidth = OH.settings.xfadeDefine.elementalSync.contentMinWidth;
			var transformPropName = OH.transitionalStyleProperty("transform", "_");
			var transformOriginPropName = OH.transitionalStyleProperty("transform-origin", "_");
			var resizedTask = function(){
			};
			$(window).on("resize", resizedTask);
			resizedTask();

			return {
				start :function(){
					window.setTimeout(function(){
						autoShift = true;
						tasks.next();
					}, props.interval);
				},
				current : function(){
					return items[nextIndex < 0 ? currentIndex : nextIndex];
				}
			}
		}

		return control;
	})();
})(jQuery);
